import { Stack, Typography, Unstable_Grid2 as Grid, Chip, Avatar  } from '@mui/material';
import styles from './About.module.css';
import java from "../../img/java.png";
import python from "../../img/python.png";
import pandas from "../../img/pandas.png";
import javascript from "../../img/javascript.png";
import react from "../../img/react.png";
import github from "../../img/github.png";
import postgres from "../../img/postgresql.png";
import sap from "../../img/sap.png";

export default function About() {
    const skills = [
        {name: "Java", src: java},
        {name: "Python", src: python},
        {name: "Pandas", src: pandas},
        {name: "Javascript", src: javascript},
        {name: "ReactJS", src: react},
        {name: "Git", src: github},
        {name: "PostgreSQL", src: postgres},
        {name: "SAP ABAP", src: sap},
    ];

    return (
        <div className={styles.container} id="about">
            <Stack 
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
            >
                <Typography variant="h4" color="rgba(255, 255, 255, 87)">About Me</Typography>
                <Typography variant="h6" color="rgba(255, 255, 255, 87)" maxWidth="50vw" minWidth="300px" align="justify">
                    I'm currently a final-year Computer Science student at the National University of Singapore.
                </Typography>
                <Typography variant="h6" color="rgba(255, 255, 255, 87)" maxWidth="50vw" minWidth="300px" align="justify">
                    From my early days of tinkering with computers, I've been fascinated by the power of technology and its ability to transform our world. 
                    This passion led me to study Computer Science.
                </Typography>
                <Typography variant="h6" color="rgba(255, 255, 255, 87)" maxWidth="50vw" minWidth="300px" align="justify">
                    I enjoy discovering and learning new things, and solving things in unique ways. 
                    I am particularly interested in AI and database. I am eager to explore new opportunities for internships and apprenticeships.
                </Typography>
                <div className={styles.divider} />
                <Typography variant="h4" color="rgba(255, 255, 255, 87)">Skills</Typography>
                <Grid container rowSpacing={1} columnSpacing={1} display="flex" justifyContent="center" maxWidth="50vw" minWidth="380px">
                    {skills.map((element) => {
                        return (
                            <Chip
                                avatar={<Avatar alt={element.name} src={element.src} />}
                                label={element.name}
                                variant="outlined"
                                color="info"
                                sx={{ margin: 1 }}
                            />
                        )
                    })}
                    
                </Grid>
            </Stack>
        </div>
    );
}